// src/pages/DefaultDashboard.js

import { useEffect, useState } from 'react';
import '../styles/dashboard.css';
import api from '../services/api';
import { Link, useNavigate } from "react-router-dom";
import ProfileView from '../pages/ProfileView';
import GraphComponent from './Graph/GraphComponent';

const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

const getToday = () => formatDate(new Date());

const getOneMonthBack = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return formatDate(date);
};

const DefaultDashboard = ({ handleLogin, showProfile, onCloseProfile }) => {
  const [topCounts, setTopCounts] = useState({ total: 0, active: 0, inactive: 0 });
  const [topumrahCounts, setTopumrahCounts] = useState({ total_package: 0, active_packages: 0, inactive_packages: 0, expired_packages: 0, live_packages: 0 });
  const [tophajjCounts, setTophajjCounts] = useState({ total_package: 0, active_packages: 0, inactive_packages: 0, expired_packages: 0, live_packages: 0 });
  const navigate = useNavigate();

  // Helper to safely get Vendor ID from localStorage
  const getVendorId = () => {
    try {
      const vendorData = localStorage.getItem("vendor");
      return vendorData ? JSON.parse(vendorData)?.id : null;
    } catch (error) {
      console.error("Error reading vendor from localStorage:", error);
      return null;
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('vendor');
    localStorage.removeItem('vendorId');
    handleLogin(null);
  };

  useEffect(() => {
    fetchTopCounts();
    fetchTopumrahcount();
    fetchTophajjcount();
  }, []);

  // --------------------
  // API CALLS
  // --------------------

  const fetchTopCounts = async () => {
    const vendorId = getVendorId();

    if (!vendorId) {
      console.error("Vendor ID missing in localStorage");
      return;
    }

    try {
      // ✅ Updated API Endpoint
      const res = await api.get(`api/Vendorlist/packagecounts/${vendorId}`);
      console.log('Top count vendor package response:', res.data);

      const data = res?.data?.data || res?.data;

      // Adjust keys depending on exact response payload structure
      setTopCounts({
        total: data?.total_package ?? data?.total ?? 0,
        active: data?.live_package ?? data?.live_packages ?? data?.active ?? 0,
        inactive: data?.expired_package ?? data?.inactive_packages ?? data?.inactive ?? 0,
      });
    } catch (error) {
      console.error('Top count API error:', error);
    }
  };

  const fetchTopumrahcount = async () => {
    try {
      const res = await api.get('/dashboard/umrahpackgecount');
      console.log('Top count umra response:', res.data);

      setTopumrahCounts({
        total_package: res?.data?.data?.total_packages ?? 0,
        active_packages: res?.data?.data?.active_packages ?? 0,
        inactive_packages: res?.data?.data?.inactive_packages ?? 0,
        expired_packages: res?.data?.data?.expired_packages ?? 0,
        live_packages: res?.data?.data?.live_packages ?? 0,
      });
    } catch (error) {
      console.error('Top count API error:', error);
    }
  };

  const fetchTophajjcount = async () => {
    try {
      const res = await api.get('/dashboard/haajpackgecount');
      console.log('Top count hajj response:', res.data);
      setTophajjCounts({
        total_package: res?.data?.data?.total_packages ?? 0,
        active_packages: res?.data?.data?.active_packages ?? 0,
        inactive_packages: res?.data?.data?.inactive_packages ?? 0,
        expired_packages: res?.data?.data?.expired_packages ?? 0,
        live_packages: res?.data?.data?.live_packages ?? 0,
      });
    } catch (error) {
      console.error('Top count API error:', error);
    }
  };

  const handleCardClick = (type, module) => {
    navigate("/packages", {
      state: { filterType: type, moduleType: module }
    });
  };

  const handleCardPackageClick = (type, module) => {
    if (module === "umrah") {
      navigate("/umrah-packages-list", {
        state: { filterType: type, moduleType: module }
      });
    }
  };

  const handleCardhajjPackageClick = (type, module) => {
    if (module === "hajj") {
      navigate("/hajj-packages-list", {
        state: { filterType: type, moduleType: module }
      });
    }
  };

  return (
    <div className="">
      {showProfile ? (
        <ProfileView onClose={onCloseProfile} />
      ) : (
        <>
          <GraphComponent />
          <div className="dashboard-content">
            <div className="top-count-container-nav">
              <div>
                <h2 style={{ fontSize: '26px', fontWeight: '700', marginBottom: '0px' }}>Packages</h2>
              </div>
              <div className="top-count-container">

                <div className="label-container-count count-card" onClick={() => handleCardClick("total", "tour")}>
                  <p>Total Packages</p>
                  <h3>{topCounts.total}</h3>
                </div>

                <Link to={"/manage-package"} className="label-container-count count-card" onClick={() => handleCardClick("live", "tour")}>
                  <p>Live Packages</p>
                  <h3>{topCounts.active}</h3>
                </Link>

                <Link to={"/expired-packages"} className="label-container-count count-card" onClick={() => handleCardClick("expired", "tour")}>
                  <p>Expired Packages</p>
                  <h3>{topCounts.inactive}</h3>
                </Link>

              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DefaultDashboard;